import { Profile } from '../../model/Profile'

const getHomeLink = (profile: Profile, locale: string) =>
  profile?.product?.publicProduct ? `/${locale}/view` : `/${locale}/showroom`

export { getHomeLink }
